import type { ReactNode } from 'react';
import type { IColumn, ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import type { IColumnCustomizationEntry } from '@/creditflowresearch/application/BondScreener/Sidebar/useColumnsCustomization';

import columnsStyles from '../columnsTabContent.module.scss';

export const labelColumn: IColumn = {
  name: 'label',
  title: 'Column Name',
  width: 'auto',
  isDraggable: false,
  cellCallback: ({ row }: ICellProps<IColumnCustomizationEntry>): ReactNode => (
    <span className={ columnsStyles.label }>{ row.label }</span>
  ),
};
